const deprecatedColors = {
  // cyan is actually one of our accepted new colors after adopting Base UI
  // cyan is more accessible than teal.
  // Adding cyan here to extend access for the older parts of our codebase that are still using deprecated theme
  cyan: {
    normal: "#0e7c86",
    dark: "#0A6C74",
  },
  teal: {
    extraDark: "#0B6E84",
    dark: "#0B8399",
    normal: "#0A9BAE",
    light: "#D9EEF2",
    extraLight: "#E8F5F7",
  },
  purple: {
    extraDark: "#151B37",
    dark: "#313157",
    normal: "#CCD3E1",
    light: "#DEE3ED",
    extraLight: "#EBEEF4",
  },
  gray: {
    one: "#1B222C",
    two: "#222B3A",
    three: "#273347",
    four: "#465267",
    five: "#69768C",
    six: "#8590A3",
    seven: "#9FA9BC",
    eight: "#CED4DE",
    nine: "#ECEFF3",
    ten: "#F9FAFB",
    eleven: "#EEEFF2",
    twelve: "#F3F4F8",
    thirteen: "#D8DFE8",
  },
  green: {
    normal: "#1AA37B",
  },
  yellow: {
    normal: "#FADD02",
    dark: "#FFB300",
  },
  red: {
    normal: "#D12415",
  },
  white: "#FFFFFF",
};

export default deprecatedColors;
